module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_07@2x-41828d0e49536af6c00a39419a3601f6.webp";